import React, { useState, useEffect } from 'react';

const TemplateHero2 = ({ branding, images = [] }) => {
  // Use prop for images if provided, else fallback to sample array
  const backgroundImages = images.length > 0 ? images : [
    'https://images.unsplash.com/photo-1602002418816-5c0aeef426aa?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=1074',
    'https://plus.unsplash.com/premium_photo-1661964304872-7b715cf38cd1?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=1170',
    'https://images.unsplash.com/photo-1566371486490-560ded23b5e4?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=1170'
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  // Auto-advance carousel every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % backgroundImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [backgroundImages.length]);

  const styles = {
    heroContainer: {
      position: 'relative',
      height: '80vh',
      width: '100%',
      backgroundImage: `url(${backgroundImages[currentSlide]})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      textAlign: 'center',
      fontFamily: branding?.heroTitleFontFamily || 'Arial, sans-serif',
      transition: 'background-image 1s ease-in-out' // Smooth transition for background change
    },
    overlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: branding?.heroOverlayColor || 'rgba(0, 0, 0, 0.4)',
    },
    content: {
      position: 'relative',
      zIndex: 1,
    },
    title: {
      fontSize: '4rem',
      fontWeight: 'bold',
      margin: '0 0 1rem 0',
      textShadow: '2px 2px 8px rgba(0,0,0,0.6)'
    },
    subtitle: {
      fontSize: '1.25rem',
      marginBottom: '2rem',
    },
    buttonGroup: {
      display: 'flex',
      gap: '1rem',
      justifyContent: 'center',
    },
    // Carousel indicators (dots) - customizable via branding
    indicators: {
      position: 'absolute',
      bottom: '20px',
      left: '50%',
      transform: 'translateX(-50%)',
      display: 'flex',
      gap: '10px',
      zIndex: 2,
    },
    indicatorDot: {
      width: '12px',
      height: '12px',
      borderRadius: '50%',
      backgroundColor: branding?.indicatorColor || 'rgba(255, 255, 255, 0.5)', // Optional: Add to your themes if needed
      cursor: 'pointer',
      transition: 'background-color 0.3s',
    },
    activeDot: {
      backgroundColor: branding?.indicatorActiveColor || 'white', // Optional: e.g., theme's $primary
    }
  };

  const handleDotClick = (index) => {
    setCurrentSlide(index);
  };

  if (backgroundImages.length === 0) {
    return <div>No images available for carousel.</div>; // Fallback if no images
  }

  return (
    <div style={styles.heroContainer}>
      <div style={styles.overlay}></div>
      <div style={styles.content}>
        <h1 style={{ ...styles.title, color: 'white' }}>Create Lasting Memories</h1>
        <p style={styles.subtitle}>Journey with us and create stories you'll tell for a lifetime</p>
        <div style={styles.buttonGroup}>
          <button className="btn btn-primary btn-lg rounded-pill px-4">Explore Now</button>
          <button className="btn btn-outline-light btn-lg rounded-pill px-4">Learn More</button>
        </div>
      </div>
      {/* Carousel Indicators (Dots) */}
      <div style={styles.indicators}>
        {backgroundImages.map((_, index) => (
          <div
            key={index}
            style={{
              ...styles.indicatorDot,
              ...(currentSlide === index ? styles.activeDot : {}),
            }}
            onClick={() => handleDotClick(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default TemplateHero2;
